var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"height":"24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M8.082 3.15l11.15 7.168a2 2 0 0 1 0 3.364l-11.15 7.169C6.75 21.706 5 20.75 5 19.168V4.832c0-1.583 1.75-2.538 3.082-1.683zM7 4.831v14.336L18.15 12z","fill-rule":"evenodd"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }